import { useTags } from '../lib/tags.hook';
import { FieldProps } from 'formik';
import { CollectionMultiSelect } from 'shared/ui/collection-multiple-autocomplete';
import { FilterCollectionMultiSelect } from 'shared/ui/collection-multiple-autocomplete-filter';

export const TagPickerField = ({ form, field, meta, compactTags = false }: FieldProps & { compactTags?: boolean }) => {

  const { items, isLoading } = useTags();
  const tags = items.map(tag => ({ label: tag.name, value: tag.id, id: tag.id }));
  return compactTags ? (
    <FilterCollectionMultiSelect
      items={tags}
      isLoading={isLoading}
      label="Теги"
      form={form}
      field={field}
      meta={meta}
    />
  ) : (
    <CollectionMultiSelect
      items={tags}
      isLoading={isLoading}
      label="Теги"
      form={form}
      field={field}
      meta={meta}
    />
  );
};
